module.exports = __webpack_public_path__ + "fonts/CormorantUpright-Light.8909a49.ttf";